<script setup lang="ts">
import { SelectScrollDownButton, useForwardProps } from 'reka-ui'
import { ChevronDown } from 'lucide'
import type { HTMLAttributes } from 'vue'
import type { SelectScrollDownButtonProps } from 'reka-ui'
import SphIcon from '@/components/base/icon/'
import { cn } from '@/utils/shadcn/lib/utils.ts'
import { reactiveOmit } from '@vueuse/core'

defineOptions({
    compatConfig: {
        MODE: 3,
    },
})

const props = defineProps<SelectScrollDownButtonProps & { class?: HTMLAttributes['class'] }>()

const delegatedProps = reactiveOmit(props, 'class')

const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
    <SelectScrollDownButton
        data-slot="select-scroll-down-button"
        v-bind="forwardedProps"
        :class="cn('absolute inset-x-0 bottom-0 z-20 flex cursor-default items-center justify-center bg-popover py-1', props.class)"
    >
        <slot>
            <SphIcon
                :icon="ChevronDown"
                size="xs"
            />
        </slot>
    </SelectScrollDownButton>
</template>
